import React from 'react'
import moment from "moment/moment";
import {Input, Label} from 'reactstrap';
import printTeeth from "../../images/print-image.png"

class ViewForPrinting extends React.Component {

    componentDidMount() {
        if (this.props.handleMount) {
            this.props.handleMount();
        }
    }

    componentWillUnmount() {
        if (this.props.handleUnMount) {
            this.props.handleUnMount();
        }
    }

    render () {
        const patientName = this.props.isAdmin ? this.props.patientName : this.props.patientName !== undefined && this.props.patientName.first_name+' '+this.props.patientName.last_name
        return (
            <div className="view-print printingBlockMain caseSchedulingPrintingBlock" >
                <div className="view-print__title">
                    Case {this.props.patient.bookingId}
                </div>
                <div className="view-print__block">
                    <div className="view-print__info">
                        <div className="view-print__l-side">
                            <div className="view-print__list">
                                <div className="view-print__item">
                                    <span>Sending Date</span>
                                    <div>
                                        {moment(this.props.patient.sendingDate).format("YYYY-MM-DD")}
                                    </div>
                                </div>
                                <div className="view-print__item">
                                    <span>Return Date</span>
                                    <div>
                                        {moment(this.props.patient.dateOfReturn).format('YYYY-MM-DD')}
                                    </div>
                                </div>
                                <div className="view-print__item">
                                    <span>Doctor</span>
                                    <div>
                                        {this.props.dentistName}
                                    </div>
                                </div>
                                <div className="view-print__item">
                                    <span>Patient</span>
                                    <div>
                                        {patientName}
                                    </div>
                                </div>
                                <div className="view-print__item">
                                    <span>Total No. of units</span>
                                    <div>
                                        {this.props.patient.numberOfUnits || 0}
                                    </div>
                                </div>
                                <div className="view-print__item">
                                    <span>Type</span>
                                    <div>
                                        {this.props.patient.type ? this.props.patient.type.value ? this.props.patient.type.value.charAt(0).toUpperCase() + this.props.patient.type.value.slice(1) : this.props.patient.type.charAt(0).toUpperCase() + this.props.patient.type.slice(1) : ""}
                                    </div>
                                </div>
                                <div className="view-print__item">
                                    <span>Implant</span>
                                    <div>
                                        {this.props.patient.implant === '1' ? "Yes" : "No"}
                                    </div>
                                </div>
                                <div className="view-print__item">
                                    <span>Color</span>
                                    <div>
                                        {this.props.patient.color}
                                    </div>
                                </div>
                            </div>
                            <div className="view-print__case">
                                <span>CASE NOTES</span>
                                {(this.props.patient.notes) ?
                                    <div>
                                        {this.props.patient.notes}
                                    </div>
                                    :
                                    <div>
                                        {this.props.patient.notes}
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="view-print__r-side">
                            <div className="view-print__actions">
                                <div className="enclosed ">
                                    <h6 className="enclosed__title">Enclosed in the box</h6>
                                    {
                                        Object.keys(this.props.enclosedBoxObject).map((value, index) => {
                                            let find = this.props.patient.enclosedBox.find(item => {
                                                return (item === parseInt(value, 10))
                                            })
                                            return (
                                                <div key={index}>
                                                    <Label check={ true }>
                                                        <Input readOnly={true} type="checkbox" checked={ find !== undefined ? true : false } className={find !== undefined ? 'checkedCheckboxForPrint' : 'eeee'} value={value} name="type"/> <small>{ this.props.enclosedBoxObject[value].name }</small>
                                                    </Label>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <div className="implant">
                                    <div className="implant__item">
                                        <span>Implant Type</span>
                                        <div>
                                            {this.props.patient.implantType}
                                        </div>
                                    </div>
                                    <div className="implant__item">
                                        <span>Implant Size</span>
                                        <div>
                                            {this.props.patient.implantSize}
                                        </div>
                                    </div>
                                </div>
                                <div className="parts">
                                    <h6 className="parts__title">Implant Parts</h6>
                                    {
                                        Object.keys(this.props.implantsPartObject).map((value, index) => {
                                            let find = Object.keys(this.props.patient.implantParts).find(item => {
                                                return (item === value)
                                            })
                                            return (
                                                <div key={index}>
                                                    <Label check={ true }>
                                                        <Input readOnly={true} type="checkbox" checked={ this.props.patient.implantParts[value] !== undefined ? true : false } className={this.props.patient.implantParts[value] !== undefined ? 'checkedCheckboxForPrint' : ''} value={value} name="type"/>
                                                        <small>
                                                            {this.props.implantsPartObject[value].name}
                                                        </small>
                                                    </Label>
                                                    { (find !== undefined) ? <Input readOnly={true} style={{fontWeight: 'bold', background: 'none', fontSize: '16px'}} className=' custom-input implantNumberField' value={this.props.patient.implantParts[find]} type="number" placeholder="" /> : '' }
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <div className="view-print__item">
                                    <span>License</span>
                                    <div>
                                        {this.props.patient.license}
                                    </div>
                                </div>
                                <div className="view-print__item">
                                    <span>Signature</span>
                                    <div>
                                        {this.props.patient.signature}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="view-print__image">
                        <img src={printTeeth} alt="Teeth"/>
                    </div>
                </div>
            </div>
        )
    }
}

export default ViewForPrinting;



// WEBPACK FOOTER //
// ./src/components/CaseDetails/ViewForPrinting.js